import styled from "styled-components";

export const IndicatorLabelDefaultBox = styled.div`
    color: ${({theme}) => theme.colors.textMiddleDark};
`;
